(function(angular){
	'use strict';
	
	angular.module('orderFormModule', [
		'BaseConfig'
	]);

})(window.angular);